import { useEffect, useState } from 'react';
import { subscribe } from '@grubhubprod/umami-library/dist/utilities/eventManager';
import { RequireAtLeastOne } from 'src/types/RequireAtLeastOne';

export type UseSearchToolbarReturn = {
  isToolbarVisible: boolean;
};

type UseSearchBarProps = {
  callbackBeforeToggle: () => void;
  callbackAfterToggle: () => void;
};

export const useSearchToolbar = (
  props: RequireAtLeastOne<UseSearchBarProps>
): UseSearchToolbarReturn => {
  const [isToolbarVisible, setIsToolbarVisible] = useState(false);

  useEffect(() => {
    const subscription = subscribe('navBar:hidden', (data) => {
      props.callbackBeforeToggle?.();
      setIsToolbarVisible(!data.isNavBarVisible);
    });

    return () => {
      subscription();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    props.callbackAfterToggle?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isToolbarVisible]);

  return {
    isToolbarVisible,
  };
};
